/**
 * Expertise Section - What Makes Us Different
 *
 * Data-backed explanation of our capabilities and track record
 * Background: Light section with authority indicators
 */

const ExpertiseSection = () => {
  return (
    <section className="relative bg-white/90 py-16 sm:py-24 lg:py-32 overflow-hidden shadow-2xl rounded-3xl">
      {/* CONTENT CONTAINER */}
      <div className="relative z-10 max-w-[1600px] mx-auto px-4 sm:px-6">
        {/* THE DIFFERENCE */}
        <div className="bg-gradient-to-r from-slate-900 to-slate-800 rounded-2xl p-5 sm:p-8 lg:p-12 text-center">
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-4 sm:mb-6">
            The Critical Difference
          </h3>
          <p className="text-base sm:text-lg lg:text-xl text-slate-300 leading-relaxed max-w-[900px] mx-auto mb-6 sm:mb-8">
            Most consultants either understand business <em>or</em> understand
            technology. Most automation vendors sell tools without redesigning
            the underlying processes. We do both—and that's why our
            transformations deliver 10x the impact of typical implementations.
          </p>
          <div className="grid md:grid-cols-3 gap-6 max-w-[900px] mx-auto">
            <div className="bg-white/10 rounded-xl p-4 sm:p-6 border border-white/20">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#B87333] mb-2">
                50-80%
              </p>
              <p className="text-sm text-slate-300">
                Cost reduction through process optimization
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-4 sm:p-6 border border-white/20">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#B87333] mb-2">
                30-200%
              </p>
              <p className="text-sm text-slate-300">
                First-year ROI from intelligent automation
              </p>
            </div>
            <div className="bg-white/10 rounded-xl p-4 sm:p-6 border border-white/20">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-black text-[#B87333] mb-2">
                2-3x
              </p>
              <p className="text-sm text-slate-300">
                Revenue growth capacity without proportional cost increase
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
